module.exports = __webpack_public_path__ + "static/media/location.74ff9339.svg";